import { FC, useState, useContext } from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import {
  Grid,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import { useMediaQuery } from "@material-ui/core";
import view from "../../assets/images/view.svg";
import unview from "../../assets/images/unview.svg";
import { Formik, Form } from "formik";
import Textfield from "../FormsUI/Textfield";
import { Button } from "@material-ui/core";
import { PersonalInfoValidation } from "../../helpers/Validations";
import { PersonalInfoTabStyle } from "../Styles/ProfilePagesStyles";
import ChangePassword from "../Modals/ChangePassword";
import AuthContext from "../../store/Auth/AuthContext";
import UPDATEPROFILE_MUTATIONS from "../../utils/mutations/updateProfile/updateProfile";
import AlertContext from "../../store/Alert/AlertContext";
import graphQLClient from "../../utils/authHeader";
import useModal from "../../hooks/useModal";
import ChangeEmail from "../Modals/ChangeEmail";

const View = () => {
  return <img src={view} className="img-fluid" alt="Gains" />;
};
const Unview = () => {
  return <img src={unview} className="img-fluid" alt="Gains" />;
};

// const Avatarimg = () => {
//   const classes = PersonalInfoTabStyle();
//   return (
//     <Box mb={3}>
//       <Badge
//         overlap="circular"
//         anchorOrigin={{
//           vertical: "bottom",
//           horizontal: "right",
//         }}
//         badgeContent={
//           <Avatar alt="User" src={edit} className={classes.small} />
//         }
//       >
//         <Avatar alt="User" src={userimg} className={classes.large} />
//       </Badge>
//     </Box>
//   );
// };
// const Icon = () => {
//   return <img src={twitter} alt="Gains" />;
// };

const PersonalInfo: FC = () => {
  const theme = useTheme();
  const classes = PersonalInfoTabStyle();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const isActiveXS = useMediaQuery(theme.breakpoints.down("xs"));

  const { setAlert } = useContext<any>(AlertContext);
  const { getProfileData, RefreshTokens, getProfile } =
    useContext<any>(AuthContext);
  const [open2, setOpen] = useState<boolean>(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const [password, setPassword] = useState({
    showPassword: false,
    showPassword2: false,
  });

  const {isOpen, close, open} = useModal()

  const handleClickShowPassword = () => {
    setPassword({ ...password, showPassword: !password.showPassword });
  };

  const handleMouseDownPassword = (event: { preventDefault: () => void }) => {
    event.preventDefault();
  };

  const email = getProfileData?.email;
  let hide = email?.split("@")[0].length - 1; //<-- number of characters to hide
  var r = new RegExp(".{" + hide + "}@", "g");
  const emailhide = email?.replace(r, "******@");

  const INITIAL_FORM_STATE = {
    username: getProfileData?.username ?? '',
    firstName: getProfileData?.firstname,
    lastName: getProfileData?.surname,
  };

  const updateProfile = (values: { username: string }) => {
    main();
    async function main() {
      const variables = {
        updateUserInput: {
          bio: "",
          countryId: 123, // TODO: Replace countryId with the users country ID
          username: values.username.toLowerCase(),
        },
      };
      graphQLClient
        .request(UPDATEPROFILE_MUTATIONS, variables)
        .then((data) => {
          setAlert(data.updateUserProfile.message, "success");
          getProfile();
        })
        .catch((err) => {
          if (err.response?.errors[0]?.extensions?.response?.statusCode === 401) {
            RefreshTokens();
          } else {
            setAlert("Something went wrong while updating profile information. Ensure that you provide a unique username", "error");
          }
        });
    }
  };

  return (
    <Box className={classes.root} mt={isActive ? 3 : 5}>
      {/* <Avatarimg /> */}
      <Formik
        enableReinitialize
        initialValues={{
          ...INITIAL_FORM_STATE,
        }}
        validationSchema={PersonalInfoValidation}
        onSubmit={(values) => {
          updateProfile(values);
        }}
      >
        {({ values, dirty, isValid }) => (
          <Form>
            <Grid container spacing={isActive ? 2 : 3}>
              <Grid item md={6} xs={12}>
                <Typography
                  variant="subtitle1"
                  color="secondary"
                  className="fw-normal"
                >
                  Username*
                </Typography>
                <Textfield
                  name="username"
                  placeholder="Enter username"
                  margin="dense"
                />
              </Grid>
            </Grid>
            <Grid container spacing={isActive ? 2 : 3}>
              <Grid item md={6} xs={12}>
                <Typography
                  variant="subtitle1"
                  color="secondary"
                  className="fw-normal"
                >
                  Email
                </Typography>
                <Textfield
                  name="email"
                  value={password.showPassword ? email : emailhide}
                  placeholder="@mail.com"
                  margin="dense"
                  disabled={true}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <IconButton
                          aria-label="email visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          color="secondary"
                        >
                          {password.showPassword ? <Unview /> : <View />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            
            </Grid>
            <Box mt='1rem' style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '2rem'
                
              }}>
                <Typography
                  variant="body1"
                  color="secondary"
                  className="fw-bold pointer"
                  onClick={handleClickOpen}
                >
                  Change Password
                </Typography>
                <Typography
                  variant="body1"
                  color="secondary"
                  className="fw-bold pointer"
                  onClick={open}
                >
                  Change Email
                </Typography>
              </Box>
            <Box
              display="flex"
              flexDirection={isActiveXS ? "column" : ""}
              mt={isActiveXS ? 2 : 6}
            >
              <Box>
                <Button
                  type="submit"
                  variant="contained"
                  color="secondary"
                  size="large"
                  disabled={!dirty || !isValid}
                >
                  Save Changes
                </Button>
              </Box>
              {/* <Box ml={isActiveXS ? 0 : 3} mt={isActiveXS ? 3 : 0}>
              <Button
                className="socialbtn"
                variant="outlined"
                color="secondary"
                size="large"
                startIcon={<Icon />}
              >
                Connect to Twitter
              </Button>
            </Box> */}
            </Box>
            <Box mt={3}></Box>
          </Form>
        )}
      </Formik>
      <ChangePassword open={open2} setOpen={setOpen} />
      {isOpen && <ChangeEmail isOpen={isOpen} onClose={close} /> }
    </Box>
  );
};
export default PersonalInfo;
